const { QUERY_LIST, CATEGORIES_SC_MAP, CATEGORIES_NSC_MAP } = require('./constants');

const inQueryListTest = (query) => QUERY_LIST.includes(query);

const inCategoryIdsTest = (categoryIds = {}) => {
    const { categoryId, subCategoryId, nestedSubCategoryId } = categoryIds;
    const categoryEntry = CATEGORIES_SC_MAP[categoryId];

    if (!categoryEntry) {
        return false;
    }

    if (!nestedSubCategoryId) {
        return categoryEntry.includes(subCategoryId);
    }

    const subCategoryEntry = CATEGORIES_NSC_MAP[categoryId];

    if (!subCategoryEntry) {
        return false;
    }

    const nscList = subCategoryEntry[subCategoryId];

    return nscList ? nscList.includes(nestedSubCategoryId) : false;
};

module.exports = {
    inCategoryIdsTest,
    inQueryListTest
};
